import styled from 'styled-components';

import Button from '@components/Button/next';
import TabsComponent from '@components/Tabs';

export const Wrapper = styled.div``;

export const GuestContentWrapper = styled.div`
  position: relative;

  & > div {
    height: 100%;
  }
`;

export const GuestContent = styled.div`
  width: 100%;
  padding: 16px 16px 0px 16px;
  transition: max-height 0.3s ease-out;
  height: auto;
  max-height: 600px;
  border-radius: 8px;
  overflow: hidden;
  .rc-tabs-nav-add {
    display: none;
  }

  .rc-tabs-card > .rc-tabs-nav .rc-tabs-tab {
    padding: 0 0 3px 0;
    background-color: transparent;
    border: none;
    border-bottom: 2px solid transparent;
  }

  .rc-tabs-card > .rc-tabs-nav .rc-tabs-tab:not(:last-of-type) {
    height: 25px;
    margin-right: 15px;
    box-sizing: border-box;
  }
  .rc-tabs-tab-with-remove {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .rc-tabs-tab-remove {
    display: flex;
    align-items: center;
    margin: 0 0 0 6px;
    padding: 0;
    border: none;
  }
  .rc-tabs-nav-list {
    display: flex;
    margin: 0 0 16px;
    cursor: pointer;
  }
  .rc-tabs-tab-active {
    border-bottom: 2px solid ${({ theme }) => theme.palette.coral} !important;
    & div {
      color: ${({ theme }) => theme.palette.tomato};
      text-shadow: 0 0 0.25px ${({ theme }) => theme.palette.tomato};
    }
  }
  .rc-tabs-tab {
    margin-right: 10px;
  }

  .rc-tabs-nav-list {
    display: flex;
  }

  .rc-tabs-tab-btn {
    :hover {
      color: ${({ theme }) => theme.palette.coral};
    }
  }
`;

export const GuestTabs = styled(TabsComponent)``;

export const AddNewRoomBox = styled.div`
  height: 80px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
`;

export const AddNewRoomButton = styled(Button)`
  border-width: 0px !important;
  background-color: transparent;
  box-shadow: none;
  display: flex;
  align-items: center;
  gap: 2px;
  span {
    max-height: 20px !important;
  }

  &:hover {
    background-color: white !important;
  }
  &:focus {
    background-color: transparent;
  }
`;

export const RoomButton = styled(Button)`
  border-width: 0px !important;
  background-color: transparent;
  box-shadow: none;
  display: flex;
  align-items: center;
  span {
    max-height: 20px !important;
  }

  &:hover {
    background-color: white !important;
  }
  &:focus {
    background-color: transparent;
  }
`;

export const AddNewRoomButtonText = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.coral};
  margin-top: -2px;
`;

export const StyledListingGuestRoom = styled.div`
  width: 100%;

  height: auto;
  display: flex;
  padding-bottom: 10px;

  .responsive-room-delete-box {
    background-color: transparent;
    border: none;
    display: flex;
    align-items: center;
  }

  &:last-of-type {
    display: block;
  }
`;

export const GuestRoomBlock = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const GuestRoomInfo = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const GuestRoomText = styled.div`
  margin-right: 6px;
  margin-top: -3px;
`;

export const GuestRoomTitle = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const GuestRoomSubtitle = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.clearBlue};
`;

export const GuestScrollWrapper = styled.div<{ isOverflow?: boolean }>`
  height: auto;
  overflow-y: ${({ isOverflow }) => (isOverflow ? 'scroll' : 'hidden')};
  margin-right: ${({ isOverflow }) => (!isOverflow ? '5px' : '0')};
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;

    background-color: ${({ theme }) => theme.palette.gray};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${({ theme }) => theme.palette.brownishGrey};
  }
  & > div {
    border-bottom: 1px solid rgba(41, 42, 44, 0.15);
    margin-bottom: 10px;
  }

  & > div:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding: 0;
  }
`;

export const GuestChildAgePicker = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 110px;
  grid-gap: 0 10px;
  padding: 0;
  overflow: auto;

  ::-webkit-scrollbar {
    display: none;
  }

  ::-webkit-scrollbar-thumb {
    display: none;
  }

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: repeat(2, 160px);
    padding: 0;
  }
`;

export const SearchGuestItem = styled.div`
  width: auto;
  height: 78px;
  background-color: ${({ theme }) => theme.palette.NL20};
  user-select: none;
  padding: 20px;

  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 20;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const SearchGuestItemContent = styled.div``;
export const SearchGuestItemTextWrapper = styled.div`
  flex: 1;
  margin-left: 4px;
`;

export const SearchGuestIconWrapper = styled.div`
  position: absolute;
  top: 30px;
  right: 20px;
`;
export const SearchGuestItemLabel = styled.span`
  height: 20px;
  font-size: 12px;
  font-weight: bold;
  text-overflow: ellipsis;
  opacity: 0.5;
  color: ${({ theme }) => theme.palette.D500};
`;

export const SearchGuestItemText = styled.span`
  display: block;
  width: 100%;
  height: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.D500};
`;
export const SearchWrapper = styled.div`
  height: 100%;
`;
